/**
 * Utilidades para generación y validación de contraseñas según política mínima:
 * - ≥ 8 caracteres
 * - ≥ 1 mayúscula
 * - ≥ 1 minúscula
 * - ≥ 1 número
 * - ≥ 1 carácter especial
 */

const UP = "ABCDEFGHJKLMNPQRSTUVWXYZ";       // sin I/O para evitar confusión
const LO = "abcdefghijkmnopqrstuvwxyz";       // sin l
const NU = "23456789";                         // sin 0/1
const SP = "!@#$%^&*?-_+";

function pick(s) {
  const arr = new Uint32Array(1);
  crypto.getRandomValues(arr);
  return s[arr[0] % s.length];
}

function shuffle(str) {
  const a = str.split("");
  for (let i = a.length - 1; i > 0; i--) {
    const r = new Uint32Array(1);
    crypto.getRandomValues(r);
    const j = r[0] % (i + 1);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a.join("");
}

export function generatePassword(length = 12) {
  const all = UP + LO + NU + SP;
  let out = pick(UP) + pick(LO) + pick(NU) + pick(SP);
  for (let i = out.length; i < length; i++) out += pick(all);
  return shuffle(out);
}

export function passwordChecks(pw) {
  pw = pw || "";
  return {
    length: pw.length >= 8,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /\d/.test(pw),
    special: /[^A-Za-z0-9]/.test(pw),
  };
}

export function isPasswordValid(pw) {
  const c = passwordChecks(pw);
  return c.length && c.upper && c.lower && c.digit && c.special;
}

export const PASSWORD_RULES = [
  { key: "length",  label: "Mínimo 8 caracteres" },
  { key: "upper",   label: "Al menos una mayúscula (A-Z)" },
  { key: "lower",   label: "Al menos una minúscula (a-z)" },
  { key: "digit",   label: "Al menos un número (0-9)" },
  { key: "special", label: "Al menos un carácter especial" },
];
